import api from "../../components/api"
import { TaxRate } from "./taxRate"

export const getTaxRates = async (): Promise<TaxRate[]> => {
  return (await api.get(`/web/invoicing/tax-rates`)).data
}

export type CreateTaxRateRequest = {
  name: string
  rate: number
  isDefault: boolean
  sortIndex: number
}

export const createTaxRate = async (data: CreateTaxRateRequest): Promise<void> => {
  await api.post(`/web/invoicing/tax-rates/create`, data)
}

type UpdateTaxRateRequest = {
  taxRateId: string
  name?: string
  rate?: number
  isDefault?: boolean
  sortIndex?: boolean
}

export const updateTaxRate = async (data: UpdateTaxRateRequest): Promise<void> => {
  await api.post(`/web/invoicing/tax-rates/update`, data)
}

export const setDefaultTaxRate = async (taxRateId: string): Promise<void> => {
  await api.post(`/web/invoicing/tax-rates/${taxRateId}/make-default`)
}

export const makeAutomaticTaxRateDefault = async (): Promise<void> => {
  await api.post(`/web/invoicing/tax-rates/make-automatic-default`)
}

export const changeAutomaticTaxRateActiveStatus = async (isActive: boolean): Promise<void> => {
  await api.post(`/web/invoicing/tax-rates/change-automatic-active-status`, { isActive })
}

type ReorderData = {
  taxRateId: string
  sortIndex: number
}

export const reorderTaxRates = async (data: ReorderData[]): Promise<void> => {
  await api.post(`/web/invoicing/tax-rates/reorder`, data)
}

export const deleteTaxRate = async (taxRateId: string): Promise<void> => {
  await api.delete(`/web/invoicing/tax-rates/${taxRateId}`)
}

type UpdateTaxRateActiveStatusRequest = {
  taxRateId: string
  isActive: boolean
}

export const updateTaxRateActiveStatus = async (data: UpdateTaxRateActiveStatusRequest): Promise<void> => {
  await api.post(`/web/invoicing/tax-rates/change-active-status`, data)
}